
import AdminTransact from "../components/superadmin/AdminInvoice";

export default function SuperInvoice() {
  return (
    <div>
      <AdminTransact />
    </div>
  );
}
